module.exports = __webpack_public_path__ + "static/img/buslicence.2163455.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buslicence.png
// module id = tfJs
// module chunks = 0